const OPEN_CONFIGURATOR = 'OPEN_CONFIGURATOR';
const OPEN_CONFIGURATOR_UNAVAILABLE = 'OPEN_CONFIGURATOR_UNAVAILABLE';

export { OPEN_CONFIGURATOR, OPEN_CONFIGURATOR_UNAVAILABLE };
//# sourceMappingURL=actions.js.map
